<script>

import {axios} from '../mixins';

export default {

  name: 'ReEnrollmentPrompt',

  mixins: [axios],

  props: {
    isAdmin: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    farmId: {
      type: Number,
      required: true
    },
    farmName: {
      type: String,
      required: true,
    },
    // Name of whitelabel
    llcName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      error: null,
      notInterested: false,
      areYouSure: false,
    };
  },

  methods: {
    reEnroll() {
      this.loading = true
      this.post('/re-enroll', {user_id: this.userId, farm_id: this.farmId}).then((response) => {
        if (response.data.status !== 200) {
          this.loading = false;
          this.error = response.data.message;
        } else {
          window.location = response.data.redirect;
        }
      }).catch((err) => {
        this.loading = false
        this.error = 'Loading past enrollment failed.'
      })
    },

    enrollmentDeclined() {
      this.notInterested = true
      if (!this.isAdmin) {
        this.post('/re-enroll-declined').then((response) => {
        })
      }
    },
  },
};

</script>

<template>
  <div class="w-full" id="re-enroll">

    <div class="mb-2 border-b text-xl font-semibold">
      Re-enrollment
    </div>

    <div v-if="loading" class="flex flex-row justify-center">
      <span class="text-xl">
        <i class="fas fa-spinner-third"></i>
      </span>
      <div class="my-auto ml-4 text-grey-light">
        Loading...
      </div>
    </div>

    <div v-else-if="error" class="text-red-light">
      {{ error }}
    </div>

    <div v-else>
      <div class="flex flex-col">
        <div v-if="notInterested">
          Thanks for your previous enrollment.
        </div>
        <div v-else-if="areYouSure">
          <p class="mb-2">
            Are you sure?
          </p>

          <button type="button" @click="areYouSure = false" class="tile-shadow rounded hover:bg-grey-lighter p-2 text-center">
            Cancel, take me back!
          </button>
          <button type="button" @click="enrollmentDeclined()" class="tile-shadow rounded hover:bg-grey-lighter p-2 text-center float-right">
            Yes, not interested.
          </button>
        </div>
        <div v-else>
          <p class="mb-2">
            You have previously enrolled in {{ this.llcName }}. Would you like to re-enroll
            your fields for {{ this.farmName }} this year?
          </p>

          <button type="button" @click="areYouSure = true"
                  class="hover:bg-grey-lighter w-1/4 text-center p-2 tile-shadow rounded">
            No
          </button>

          <button type="button"
                  class="hover:bg-green-darker rounded w-1/4 text-center text-white tile-shadow p-2 bg-green float-right"
                  @click="reEnroll()">
            Yes, Re-Enroll
          </button>

        </div>

      </div>
    </div>

  </div>
</template>
